import { all } from 'redux-saga/effects';
import authSaga from './auth';
import favoriteTestSaga from './favoriteTest';
import goodsCategorySaga from './goodsCategory';
import seqConsult from './seqConsult';
import shopSearchSaga from './shopSearch';
import trackingSaga from './tracking';
import webappSaga from './webapp';

export default function* rootSaga() {
  yield all([
    authSaga(),
    webappSaga(),
    favoriteTestSaga(),
    goodsCategorySaga(),
    shopSearchSaga(),
    trackingSaga(),
    seqConsult(),
  ]);
}
